module.exports = "/_next/static/images/slide9-7efc2dc4d9012916de23bb8659c53857.webp";